import { object, string, array, number } from "yup"

import Presenter from "./views/Presenter"
import BusinessInfo from "./views/BusinessInfo"
// import OtherInfo from "./views/OtherInfo"
import Shareholders from "./views/Shareholders"

export default [
  {
    id: "business_info",
    component: BusinessInfo,
    initialValues: {
      suffix: "",
      preferred_name1: "",
      preferred_name2: "",
      preferred_name3: "",
      preferred_name4: "",
      business_nature: "",
      category: null,
      address: "",
      country: "",
      state: "",
      city: "",
    },
    validationSchema: object().shape({
      suffix: string().required("Required"),
      preferred_name1: string().required("Provide a sample Preferred Name 1"),
      preferred_name2: string().required("Provide a sample Preferred Name 2"),
      preferred_name3: string().required("Provide a sample Preferred Name 3"),
      preferred_name4: string().required("Provide a sample Preferred Name 4"),
      business_nature: string().required("Required"),
      category: string().required("Required"),
      address: string().required("Required"),
      country: string().required("Provide your country"),
      city: string()
        .matches(/^[a-zA-Z\s]*$/, "City is invalid")
        .required("Indicate city where business is located"),
      state: string().required(
        "Kindly indicate state where business is located"
      ),
    }),
    actionLabel: "Next",
  },
  {
    id: "shareholder_info",
    component: Shareholders,
    actionLabel: "Next",
    initialValues: {
      isShareholder: "",
    },
    validationSchema: object().shape({
      isShareholder: string().required("Please add a shareholder"),
    }),
  },
  {
    id: "presenter_info",
    component: Presenter,
    initialValues: {
      company_secretary: "",
      secretary_type: "",
      secretary_firstname: "",
      secretary_surname: "",
      secretary_address: "",
      secretary_country: "",
      secretary_state: "",
      secretary_city: "",
      secretary_email: "",
      secretary_phone: "",
      identity_number: "",
      identity_type: "",
      identity: "",
    },
    validationSchema: object().shape({
      company_secretary: string().required("Required"),
    }),
    actionLabel: "Confirm",
  },
]
